import * as s from './Logo.scss';

interface LogoProps {
  t(key: string): string;
}

export const Logo = ({ t }: LogoProps) => {
  return `
    <div class="${s.logo}">
      <a class="${s.link}" title="${t('logo_title')}" href="https://www.wix.com" data-hook="wix-header-logo-link"></a>
    </div>
  `;
};
